





















































































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import DeleteModal from '@/app/components/Common/DeleteModal.vue'
import Loading from '@/app/components/Common/Loading.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
/* api */
import MachineMaintenanceDetailApi from '@/app/model/api/machineMaintenanceDetailApi'
import MachineMaintenanceCreateApi from '@/app/model/api/machineMaintenanceCreateApi'
import MachineMaintenanceEditApi from '@/app/model/api/machineMaintenanceEditApi'
import MachineMaintenanceDeleteApi from '@/app/model/api/machineMaintenanceDeleteApi'
import AccountListApi from '@/app/model/api/accountListApi'
import MachineDetailApi from '@/app/model/api/machineDetailApi'
/* module */
import CommonClass from '@/app/module/common'
import Validator from '@/app/module/validator'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'
import Local from '@/app/module/local'
import DateClass from '@/app/module/date'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    ErrorModal,
    DeleteModal,
    Loading,
    Error409Modal,
    ErrorInfo,
    Datepicker
  }
})
export default class MaintenanceMaintenanceCreate extends Vue {
  private errorMessages: any = ''
  private alertText: string = ''
  private alertTitle: string = ''
  private maintenanceData: any = {
    machine_id: null,
    work_date: '',
    user_id: '',
    machine_maintenance_items: [],
    remarks: ''
  }
  private accountData: any = {}
  private machineData: any = {}
  private constantValue: any = []
  private maintenanceItems: any = []
  /* 表示非表示 */
  private showServerErrorModal: boolean = false
  private showDeleteModal: boolean = false
  private showLoading: boolean = true
  private isEdit: boolean = false
  private showError409Modal: boolean = false
  private show400ErrorMessage: boolean = false
  /* datepicker */
  private japanese: any = ja
  private form: any = 'yyyy-MM-dd'

  created () {
    this.getAccountList()

    if (this.$route.path.indexOf('/create') === -1) {
      this.isEdit = true
      this.getDetail()
    } else {
      this.getMachineList()
      this.maintenanceData.work_date = new Date()
      this.isEdit = false
    }
  }

  private getMachineList () {
    (async () => {
      const result = await MachineDetailApi.getMachineDetail(this.$route.params.machine_id)
      if (result.isOk()) {
        this.machineData = result.getPayload().machine
        let items = this.workItems()
        for (let i in items) {
          items[i].category_name = this.judgmentCategoryName(items[i].category_id)
          items[i].subcategory_name = this.judgmentSubCategoryName(items[i].subcategory_id)
        }
        this.maintenanceItems = items
        for (let i in this.maintenanceItems) {
          if (this.categorys.indexOf(this.maintenanceItems[i].category_name) === -1) {
            this.categorys.push(this.maintenanceItems[i].category_name)
          }
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  private workItems () {
    // セレクトボックス情報取得
    this.constantValue = JSON.parse(Local.getConstantValue()!)
    for (let i in this.constantValue.machine_types) {
      if (this.constantValue.machine_types[i].machine_type_id === this.machineData.machine_type) {
        return this.constantValue.machine_types[i].maintenance_items
      }
    }
  }

  /* 同じ大分類の件数 */
  private judgmentCategoryNameCount (name: string) {
    let count = this.maintenanceItems.filter((data: any) => data.category_name === name)
    return count.length
  }

  /* 同じ中分類の件数 */
  private judgmentSubategoryNameCount (name: string) {
    let count = this.maintenanceItems.filter((data: any) => data.subcategory_name === name)
    return count.length
  }

  private categorys: any = []

  private judgmentCategoryBg (name: string) {
    let num = this.categorys.indexOf(name)
    if (num % 2 === 0) {
      return false
    } else {
      return true
    }
  }

  /* 大項目名の判定 */
  private judgmentCategoryName (id: number) {
    for (let i in this.constantValue.maintenance_categories) {
      if (this.constantValue.maintenance_categories[i].category_id === id) {
        return this.constantValue.maintenance_categories[i].category_name
      }
    }
  }

  /* 中項目名の判定 */
  private judgmentSubCategoryName (id: number) {
    for (let i in this.constantValue.maintenance_subcategories) {
      if (this.constantValue.maintenance_subcategories[i].subcategory_id === id) {
        return this.constantValue.maintenance_subcategories[i].subcategory_name
      }
    }
  }

  private countCategory () {
    let items = this.maintenanceItems.filter((data: any) => data.category_id === 1)
  }

  private getDetail () {
    (async () => {
      const result = await MachineMaintenanceDetailApi.getMachineMaintenanceDetail(this.$route.params.maintenance_id)
      if (result.isOk()) {
        this.maintenanceData = result.getPayload().maintenance
        this.maintenanceItems = this.maintenanceData.maintenance_items
        for (let i in this.maintenanceItems) {
          if (this.categorys.indexOf(this.maintenanceItems[i].category_name) === -1) {
            this.categorys.push(this.maintenanceItems[i].category_name)
          }
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showLoading = false
    })()
  }

  // 生産者情報取得
  private getAccountList () {
    (async () => {
      const data = {
        type: 0,
        text: '',
        order_name: 'name',
        sort: 'asc'
      }

      const result = await AccountListApi.getAccountList(data)

      if (result.isOk()) {
        this.accountData = result.getPayload().users
        // TODO:追加の場合は初期値はログインユーザー
        // if (!this.isEdit) {
        //   let loginUserData = this.accountData.filter((data: any) => data.user_id === userId)
        //   if (loginUserData !== 0) {
        //     this.maintenanceData.user_id = userId
        //   }
        // }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
    })()
  }

  private doSave () {
    /* バリデーションチェック */
    if (!this.doValidate()) {
      window.scrollTo({ top: 0, behavior: 'auto' })
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      return
    } else {
      this.show400ErrorMessage = false
    }
    this.showLoading = true
    let items = []
    for (let i in this.maintenanceItems) {
      items.push({
        maintenance_item_id: this.maintenanceItems[i].maintenance_item_id,
        working_content: this.maintenanceItems[i].working_content
      })
    }

    if (this.isEdit) {
      this.doEdit(items)
    } else {
      this.doCreate(items)
    }
  }

  private async doCreate (items: any) {
    const bodyData: any = {
      machine_id: parseInt(this.$route.params.machine_id),
      work_date: DateClass.dateToStringYmd(this.maintenanceData.work_date, '-'),
      user_id: this.maintenanceData.user_id,
      machine_maintenance_items: items,
      remarks: this.maintenanceData.remarks
    }

    const result = await MachineMaintenanceCreateApi.doMachineMaintenanceCreate(bodyData)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '機械メンテナンス登録が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/machine/' + this.$route.params.machine_id).catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'POST', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    this.showLoading = false
  }

  private async doEdit (items: any) {
    const bodyData: any = {
      user_id: this.maintenanceData.user_id,
      machine_maintenance_items: items,
      remarks: this.maintenanceData.remarks,
      time_stamp: this.maintenanceData.time_stamp
    }

    const result = await MachineMaintenanceEditApi.doMachineMaintenanceEdit(this.$route.params.maintenance_id, bodyData)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '機械メンテナンス編集が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/machine/' + this.$route.params.machine_id).catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    this.showLoading = false
  }

  private doValidate () {
    // リセット
    this.errorMessages = {}

    const userNameFlag = Validator.validateInputWorkerName('userNameErrorMessage', this.maintenanceData.user_id)
    const workDateFlag = Validator.validateInputWorkDate('workDateErrorMessage', this.maintenanceData.work_date)
    const remarksFlag = Validator.validateInputRemarks('remarksErrorMessage', this.maintenanceData.remarks)
    this.errorMessages = Object.assign({}, this.errorMessages, Validator.getErrorMessage())

    let isError = true
    for (let i in this.maintenanceItems) {
      if (this.maintenanceItems[i].working_content !== undefined &&
          this.maintenanceItems[i].working_content !== null &&
          this.maintenanceItems[i].working_content.length > 255) {
        this.$set(this.errorMessages, 'workingContentErrorMessage', '作業内容は255文字以下で入力してください。')
        isError = false
      }
    }

    return userNameFlag && workDateFlag && remarksFlag && isError
  }

  private doDelete () {
    (async () => {
      this.showLoading = true
      const result = await MachineMaintenanceDeleteApi.doMachineMaintenanceDelete(this.$route.params.maintenance_id)

      if (result.isOk()) {
        this.$store.commit('alertState/setAlertMessage', { type: 0, text: '機械メンテナンスを削除しました。' })
        this.$store.commit('alertState/setAlertFlag', true)
        this.$router.push('/master/machine/' + this.$route.params.machine_id).catch(e => {})
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'DELETE', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertTitle = errorData.alertTitle
          this.alertText = errorData.alertText
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showDeleteModal = false
      this.showLoading = false
    })()
  }

  private doCancel () {
    this.$router.push('/master/machine/' + this.$route.params.machine_id).catch(e => {})
  }
}
